import React from "react"
export function Call(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M12.498 2.803a1 1 0 01.993.884l.007.116v3a1 1 0 01-.884.993l-.116.007H8.83c-.21.83-.315 1.832-.315 3.006 0 1.17.105 2.169.314 2.996l3.669-.002a1 1 0 011 1v3a1 1 0 01-1 1h-1.5l-.11-.004c-3.26.004-4.89-2.66-4.89-7.988 0-5.338 1.63-8.008 4.89-8.008h1.61z"
        fill="currentColor"
        transform="rotate(-30 9.748 10.803)"
        id="prefix__call"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
